import React, { FC } from 'react'
import { useFormik } from 'formik'
import { LoadingButton } from '../../../components/_EOS/Button/LoadingButton'

import { Status } from '../../../hooks/useFetchState'
import { ActionDispatchStateDto } from '../DTO/ActionDispatchStateDto'
import { ActionDispatchStateSchema } from './Schema'
import { useApi } from '../../../hooks/useApi'
import { update } from '../api'

import { Container, makeStyles, createStyles } from '@material-ui/core'
import { ActionDispatchStateForm } from './ActionDispatchStateForm'
import { useHistory } from 'react-router-dom'


interface Props {
    actionDispatchState: ActionDispatchStateDto
}

export const EditForm: FC<Props> = ({
    actionDispatchState
}) => {
    const styles = useStyles()
    const history = useHistory()
    const { state, callApi } = useApi()

    const {
        values,
        errors,
        handleChange,
        submitForm
    } = useFormik<ActionDispatchStateDto>({
        initialValues: actionDispatchState,
        onSubmit: (values: ActionDispatchStateDto) => {
            sendData(values)
        },
        validationSchema: ActionDispatchStateSchema,
        validateOnChange: true
    })

    const sendData = (actionDispatchState: ActionDispatchStateDto) => {
        callApi(update(actionDispatchState))
            .then(() => {
                history.goBack()
            })
    }

    const handleSubmitForm = () => {
        submitForm()
    }

    return (
        <Container className={styles.editContainer}>
            <ActionDispatchStateForm values={values} errors={errors} handleChange={handleChange} disabled={true} />
            <div className={styles.buttonContainer}>
                <LoadingButton loading={state.status === Status.Loading} onClick={handleSubmitForm}>
                    Editar
                </LoadingButton>
            </div>
           
        </Container>
    )
}

const useStyles = makeStyles(
    createStyles({
        editContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: 10,
        },
        editInput: {
            marginBottom: 30,
        },
        buttonContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
        }
    })
)